import { render, staticRenderFns } from "./SetTarget.vue?vue&type=template&id=35b39ea7&scoped=true&"
import script from "./SetTarget.vue?vue&type=script&lang=js&"
export * from "./SetTarget.vue?vue&type=script&lang=js&"
import style0 from "./SetTarget.vue?vue&type=style&index=0&id=35b39ea7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b39ea7",
  null
  
)

export default component.exports